module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10066.ee4ee194.jpg";